module.exports = __webpack_public_path__ + "static/media/House 2.70a7ed59.svg";